import { CallStatusCardProps } from "declarations/card";
import { formatDate } from "functions/text";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "router/Paths";
import { IoCallOutline, IoCarSportOutline, IoChevronForward } from "react-icons/io5";

function CallStatusCard({ click }: CallStatusCardProps) {
  const navigate = useNavigate();

  const handleDetails = () => {
    if (!click.car?._id) return;
    navigate(`${Paths.cars}/${click.car?._id}`);
  };

  const handleOnCustomerPress = () => {
    if (!click.user?._id) return;
    navigate(`${Paths.users}/${click.user?._id}`);
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.icon}><IoCallOutline size={18} /></div>
      <button type="button" className={Classname.customer} onClick={handleOnCustomerPress}>
        <strong>{click.user?.name || "Unknown buyer"}</strong>
        <span>{click.user?.phoneNumber || "Phone unavailable"}</span>
      </button>
      <div className={Classname.car}><IoCarSportOutline size={15} /><span>{click.car?.model || click.car?.tag || "Listing"}</span></div>
      <span className={Classname.date}>{formatDate(click.createdAt)}</span>
      <button onClick={handleDetails} className={Classname.detailsButton} aria-label="View car"><IoChevronForward size={18} /></button>
    </div>
  );
}

export default CallStatusCard;

const Classname = {
  container: "grid grid-cols-[36px_minmax(0,1fr)_auto] items-center gap-2 rounded-xl border border-slate-200 bg-white p-3 text-sm shadow-sm",
  icon: "flex h-9 w-9 items-center justify-center rounded-full bg-emerald-50 text-emerald-700",
  customer: "min-w-0 text-left [&>strong]:block [&>strong]:truncate [&>strong]:text-sm [&>strong]:text-slate-900 [&>span]:block [&>span]:truncate [&>span]:text-xs [&>span]:text-slate-500",
  car: "col-start-2 flex min-w-0 items-center gap-1.5 text-xs text-slate-600 [&>span]:truncate",
  date: "col-start-2 text-[11px] text-slate-400",
  detailsButton: "col-start-3 row-start-1 row-span-3 flex h-8 w-8 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100",
};
